<app-dialog-header
  [header]="'library.user_card.dialog.change_password.header' | translate"
  iconClass="icon-change-pass-icon"
>
</app-dialog-header>
<app-dialog-content>
  <div class="p-grid">
    <div class="p-col-12">
      <label
        for="oldPassword"
        class="form-control-container-label"
      >
        {{ 'library.user_card.dialog.change_password.old_password.label' | translate }}
      </label>
      <app-password
        id="oldPassword"
        [appApiErrors]="errors()?.currentPassword"
        [formControl]="oldPassword"
        [optional]="false"
        data-qa="change-password-old-password-input"
      >
      </app-password>
      <app-form-control-error [control]="oldPassword"></app-form-control-error>
    </div>
    <div class="p-col-12">
      <ui-change-password-control
        [errors]="errors()"
        [formControl]="passwordControl"
        [strengthConfig]="strengthConfig()"
        [strengthValidatorConfig]="strengthConfig()"
      ></ui-change-password-control>
    </div>
  </div>
</app-dialog-content>
<div class="dialog-footer">
  <button
    [disabled]="requestPending()"
    (click)="close()"
    data-qa="account-settings-change-password-close-button"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.cancel.label' | translate }}
  </button>
  <button
    [disabled]="requestPending()"
    (click)="onSubmit()"
    data-qa="account-settings-change-password-submit-button"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'button.submit.label' | translate }}
  </button>
</div>
